import { realEstateAgentFavoriteLoanOfficersHooks } from 'reducers/slices/realEstateAgent/favoriteLoanOfficersSlice';
import { useFetchStatus } from 'utils/fetchStatusUtils';

const useFavoriteLoanOfficers = () => {
  const {
    favoriteLoanOfficers,
    loadFavoriteLoanOfficers,
    createFavoriteLoanOfficer,
    favoriteLoanOfficer,
    deleteFavoriteLoanOfficer,
    updateFavoriteLoanOfficer,
  } = realEstateAgentFavoriteLoanOfficersHooks.use();

  return {
    isFavoriteLoanOfficersLoading: useFetchStatus(favoriteLoanOfficers.loadingStatus).isPending,
    deleteFavoriteLoanOfficer,
    isFavoriteLoanOfficerDeleting: useFetchStatus(favoriteLoanOfficer.deleteStatus).isPending,
    isFavoriteLoanOfficersIdle: useFetchStatus(favoriteLoanOfficers.loadingStatus).isIdle,
    favoriteLoanOfficers: favoriteLoanOfficers.items,
    loadFavoriteLoanOfficers,
    createFavoriteLoanOfficer,
    isFavoriteLoanOfficerCreating: useFetchStatus(favoriteLoanOfficer.creatingStatus).isPending,
    updateFavoriteLoanOfficer,
    isFavoriteLoanOfficerUpdating: useFetchStatus(favoriteLoanOfficer.updatingStatus).isPending,
  };
};

export default useFavoriteLoanOfficers;



// WEBPACK FOOTER //
// ./src/reducers/hooks/realEstateAgent/useFavoriteLoanOfficers.js